// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":has(+.app__RaiseDisputePopup__raise_dispute_upload_documents){display:none}", "",{"version":3,"sources":["webpack://./../common/wni-ce/capabilities-react/wnice-capability-policy-react/RaiseDisputePopup/RaiseDisputePopup.module.scss"],"names":[],"mappings":"AAAA,+DACI,YAAA","sourcesContent":["*:has(+ .raise_dispute_upload_documents) {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"raise_dispute_upload_documents": "app__RaiseDisputePopup__raise_dispute_upload_documents"
};
export default ___CSS_LOADER_EXPORT___;
